import React from "react";
import { StyleProp, StyleSheet, TextInput, TextInputProps, TextStyle, View } from "react-native";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { PdSearch } from "../Icons";

const PdSearchInput = React.forwardRef<TextInput, TextInputProps & { contentContainerStyle?: StyleProp<TextStyle> }>(
  ({ contentContainerStyle, style, ...rest }, ref) => {
    return (
      <View style={[styles.container, style]}>
        <View style={styles.iconContainer}>
          <PdSearch style={styles.icon} />
        </View>
        <TextInput
          style={[styles.textInput, contentContainerStyle]}
          placeholderTextColor={kColors.gray500}
          ref={ref}
          placeholder="Search"
          {...rest}
        />
      </View>
    );
  },
);

export default PdSearchInput;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: kColors.grayPink,
    flexDirection: "row",
  },
  icon: {
    color: kColors.gray500,
    height: 12,
    width: 12,
  },
  iconContainer: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100%",
    paddingRight: kStyleConst.kSpacing * 4,
  },
  textInput: {
    color: kColors.brandDark,
    flex: 1,
    fontFamily: "Poppins",
    fontSize: 10,
    height: 40,
    letterSpacing: 0.8,
    textTransform: "uppercase",
  },
});
